import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Play, Pause, MonitorOff } from "lucide-react";
import share from "../svg/share.svg";
import endorse from "../svg/endorse.svg";
import Initials from "../Initials";
import EndorseCampaignModal from "../Modals/EndorseCampaignModal";
import PaymentMethodModal from "../Modals/PaymentMethodModal";
import InsufficientWalletBalanceModal from "../Modals/InsufficientWalletBallance";
import SummaryModal from "../Modals/SummaryModal";
import EndorsementSuccessfulModal from "../Modals/EndorsementSuccessfulModal";
import ShareCampaignModal from "../Modals/ShareCampaignModal";
import { baseURL } from "../URL";
import usePost from "../Hooks/usePost";
import { toast } from "sonner";
import { isAuthenticated } from "../authentication/auth";
import { MonitorCheck } from "lucide-react";
import SignInFirst from "./SignInFirst";
import Carousel from "react-material-ui-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HomeCampaign = ({ item }: any, index: any) => {
  const navigate = useNavigate();
  const userData: any = window.localStorage.getItem("userData");
  const parsedUserData = JSON.parse(userData);
  const [endorseMenu, setEndorseMenu] = useState(false);
  const [signInFirstModal, setSignInFirstModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unitsToPurchase, setUnitsToPurchase] = useState<number>(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [paymentMethodModal, setPaymentMethodModal] = useState(false);
  const [endorsementNote, setEndorsementNote] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [allData, setAllData] = useState<any>({});
  const [insufficientWalletModal, setInsufficientWalletModal] = useState(false);
  const [summaryModal, setSummaryModal] = useState(false);
  const [endorsementSuccessfulModal, setEndorsementSuccessfulModal] = useState(false);
  const [shareCampaignModal, setShareCampaignModal] = useState(false);
  
  // Video states
  const [videoPlaying, setVideoPlaying] = useState<boolean[]>([]);
  const [showVideoControls, setShowVideoControls] = useState<boolean[]>([]);
  const [videosInView, setVideosInView] = useState<boolean[]>([]);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const campaignRef = useRef<HTMLDivElement>(null);
  
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  const maxLength = 100;
  const isUserAuthenticated = isAuthenticated();

  // Initialize video states when component mounts or when campaignFiles change
  useEffect(() => {
    const videoCount = item?.campaignFiles?.filter((file: any) => file.filePath.endsWith(".mp4")).length || 0;
    setVideoPlaying(new Array(videoCount).fill(false));
    setShowVideoControls(new Array(videoCount).fill(true));
    setVideosInView(new Array(videoCount).fill(false));
    videoRefs.current = new Array(videoCount).fill(null);
  }, [item?.campaignFiles]);

  // Intersection Observer for auto-play on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const campaignElement = entry.target as HTMLDivElement;
          const isInView = entry.isIntersecting;
          
          if (campaignElement === campaignRef.current) {
            // Handle all videos in this campaign
            videoRefs.current.forEach((video, videoIndex) => {
              if (video) {
                if (isInView) {
                  // Play video when campaign comes into view
                  video.play().catch(error => {
                    console.log('Auto-play failed:', error);
                  });
                  setVideoPlaying(prev => {
                    const newState = [...prev];
                    newState[videoIndex] = true;
                    return newState;
                  });
                  setVideosInView(prev => {
                    const newState = [...prev];
                    newState[videoIndex] = true;
                    return newState;
                  });
                } else {
                  // Pause video when campaign goes out of view
                  video.pause();
                  setVideoPlaying(prev => {
                    const newState = [...prev];
                    newState[videoIndex] = false;
                    return newState;
                  });
                  setVideosInView(prev => {
                    const newState = [...prev];
                    newState[videoIndex] = false;
                    return newState;
                  });
                }
              }
            });
          }
        });
      },
      {
        threshold: 0.6, // Play when 60% of the campaign is visible
        rootMargin: '0px'
      }
    );

    if (campaignRef.current) {
      observer.observe(campaignRef.current);
    }

    return () => {
      if (campaignRef.current) {
        observer.unobserve(campaignRef.current);
      }
    };
  }, [videoRefs.current]);

  const openEndorseMenu = () => {
    if (isUserAuthenticated) {
      setEndorseMenu(true);
    } else {
      setSignInFirstModal(true);
    }
    document.body.style.overflow = "hidden";
  };

  const closeEndorseMenu = () => {
    setEndorseMenu(false);
    document.body.style.overflow = "auto";
  };

  const onSuccess = () => {};
  const onError = () => {};
  const openSignInPrompt = () => setSignInFirstModal(true);
  const closeSignInPrompt = () => {
    setSignInFirstModal(false);
    document.body.style.overflow = "auto";
  };

  const openPaymentMethodModal = () => {
    setPaymentMethodModal(true);
    document.body.style.overflow = "hidden";
  };

  const closePaymentMethodModal = () => {
    setPaymentMethodModal(false);
    document.body.style.overflow = "auto";
  };

  const openInsufficientWalletModal = () => {
    setInsufficientWalletModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeInsufficientWalletModal = () => {
    setInsufficientWalletModal(false);
    document.body.style.overflow = "auto";
  };

  const opensummarymodal = () => {
    setSummaryModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeSummaryModal = () => {
    setSummaryModal(false);
    document.body.style.overflow = "auto";
  };

  const openShareCampaignModal = () => {
    setShareCampaignModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeShareCampaignModal = () => {
    setShareCampaignModal(false);
    document.body.style.overflow = "auto";
  };

  const openEndorsementSuccessfulModal = () => {
    setEndorsementSuccessfulModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeEndorsementSuccessfulModal = () => {
    setEndorsementSuccessfulModal(false);
    setAllData({});
    document.body.style.overflow = "auto";
  };

  const endorseWithWalletURL = `${baseURL}/Campaign/EndorseCampaignWithWallet`;
  const walletURL = `${baseURL}/Wallet/WalletProfile`;

  const {
    data: ApiFeedback,
    loading: ApiFeedbackLoading,
    error,
    postData,
  } = usePost(endorseWithWalletURL);

  const fetchWalletBalance = async () => {
    setLoading(true);

    try {
      const response = await fetch(walletURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      if (responseData) {
        setWalletBalance(responseData.data.walletBalance);
      }
    } catch (err) {
      console.log("Error posting data:", err);
    } finally {
      setLoading(false);
    }
  };

  const endorseWithWalletData = {
    campaignId: item.campaignId,
    numberOfUnits: unitsToPurchase,
    endorsementNote: endorsementNote,
  };

  const sendToFacebook = async () => {
    console.log("Sending to facebook", item);
    const apiUrl = `https://iendorse.net/endorse-campaign`;
    const formDataPayload = new FormData();
    formDataPayload.append("campaignId", item.campaignId);
    formDataPayload.append("numberOfUnits", unitsToPurchase.toString());
    formDataPayload.append("endorsementNote", endorsementNote);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formDataPayload,
      });

      const data = await response.json();
      console.log("Response received:", data);

      if (response.ok && data.succeeded) {
        console.log("Successfully Posted campaign to Facebook");
      } else {
        console.error(
          data.message ||
            "An error occurred while uploading campaign media to Facebook"
        );
      }
    } catch (error) {
      console.error("Facebook upload error:", error);
    }
  };

  const PayWithWallet = async () => {
    console.log("..........Paying with wallet");
    try {
      await postData(endorseWithWalletData);
    } catch (err) {
      console.error("Error posting data:", err);
      return;
    } finally {
      sendToFacebook();
    }
  };

  const submitEndorsement = (units: number, note: any) => {
    setUnitsToPurchase(units);
    setEndorsementNote(note);
    setAllData({ ...allData, unitsToPurchase: units, endorsementNote: note });
    fetchWalletBalance();
    closeEndorseMenu();
    openPaymentMethodModal();
  };

  const submitPaymentMethod = (method: any) => {
    setAllData({
      ...allData,
      paymentMethod: method,
      walletBalance: walletBalance,
      campaignId: item.campaignId,
    });
    setPaymentMethod(method);
    const preferredPaymentMethod = method;
    closePaymentMethodModal();
    console.log("Preferred Payment method:", preferredPaymentMethod);
    if (preferredPaymentMethod == "Wallet") {
      if (unitsToPurchase > walletBalance) {
        setInsufficientWalletModal(true);
      } else {
        opensummarymodal();
      }
    }
  };

  const getInitials = (fullName: string) => {
    if (fullName) {
      const names = fullName.trim().split(" ");
      const initials =
        (names[0] ? names[0][0] : "") +
        (names.length > 1 ? names[names.length - 1][0] : "");
      return initials.toUpperCase();
    }
    return "";
  };

  useEffect(() => {
    if (ApiFeedback) {
      console.log(ApiFeedback);
      closeSummaryModal();
      openEndorsementSuccessfulModal();
      sendToFacebook();
    }
  }, [ApiFeedback]);

  useEffect(() => {
    if (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to endorse. Please try again.");
    }
  }, [error]);

  const handleItemClick = (x: any) => {
    localStorage.setItem("listScrollPosition", window.pageYOffset.toString());
    navigate(`/viewcampaign/${x}`);
  };

  // Manual toggle function for clicking play/pause button
  const togglePlayPause = (videoIndex: number) => {
    const video = videoRefs.current[videoIndex];
    if (video) {
      if (videoPlaying[videoIndex]) {
        video.pause();
      } else {
        video.play().catch(error => {
          console.log('Play failed:', error);
        });
      }
      setVideoPlaying(prev => {
        const newState = [...prev];
        newState[videoIndex] = !newState[videoIndex];
        return newState;
      });
    }
  };

  // Handle video hover events (for showing/hiding controls)
  const handleVideoMouseEnter = (videoIndex: number) => {
    setShowVideoControls(prev => {
      const newState = [...prev];
      newState[videoIndex] = true;
      return newState;
    });
  };

  const handleVideoMouseLeave = (videoIndex: number) => {
    setShowVideoControls(prev => {
      const newState = [...prev];
      newState[videoIndex] = false;
      return newState;
    });
  };

  console.log("campaign File", item?.campaignFiles);
  console.log("home campaign", item);

  return (
    <>
      <div
        ref={campaignRef}
        key={item.campaignId}
        className="p-4 w-full max-w-lg sm:border-gray-200 sm:border bg-white rounded-2xl my-5 px-6"
      >
        {/* Header Section */}
        <div className="flex items-start justify-end sm:flex-wrap">
          <div className="mt-1 sm:mt-0">
            <div>
              {item?.isCampaignActive ? (
                
              <span className="text-green-600 font-medium">
                  <MonitorCheck className="inline w-4 h-4" />
               
                </span>
              ) : (
                <span className="text-green-600 font-medium">
                  <MonitorCheck className="inline w-4 h-4" /> Sponsored
                </span>
              )}
            </div>
          </div>
        </div>

        <Link to={`/userprofile/${item?.accountId}`}>
          <div className="flex items-start justify-between sm:flex-wrap">
            <div className="flex items-center gap-3">
              <div className="inline-block z-1">
                {item?.campaignOwnerImage ? (
                  <img
                    className="rounded-full border-2 border-white w-10 h-10 object-cover flex-shrink-0"
                    style={{ boxShadow: "0 0 0 1px #0D236E" }}
                    src={item?.campaignOwnerImage || "/placeholder.svg"}
                    alt="Avatar"
                  />
                ) : (
                  <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full text-customBlue p-2">
                    <Initials
                      fullName={item?.campaignOwner}
                      className="text-lg font-medium"
                    />
                  </div>
                )}
              </div>
              <div>
                <div className="font-semibold text-xs leading-tight max-w-[130px] break-words">
                  {item?.campaignOwner}
                </div>
                <div className="text-xs text-gray-600">
                  <i>{item?.campaignOwnerTitle}</i>
                </div>
              </div>
            </div>
          </div>
        </Link>

        {/* Campaign Title & Description */}
        <div
          onClick={() => handleItemClick(item?.campaignId)}
          className="cursor-pointer"
        >
          <div className="my-4">
            <h1 className="font-medium text-lg truncate">
              {item?.campaignTitle}
            </h1>

            <div className="mt-2">
              <p
                className="text-justify text-sm"
                style={{ whiteSpace: "pre-line" }}
              >
                {isExpanded
                  ? item?.description
                  : `${item?.description.slice(0, maxLength)}...`}
              </p>

              {item?.description?.length > maxLength && (
                <button
                  onClick={toggleReadMore}
                  className="text-customBlue font-medium mt-2"
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Media Section */}
        <div className="relative">
          <Carousel
            indicators={item?.campaignFiles.length > 1}
            navButtonsAlwaysVisible={item?.campaignFiles.length > 1}
            navButtonsProps={{
              style: {
                backgroundColor: "rgba(0,0,0,0.5)",
                color: "white",
                borderRadius: "50%",
                margin: "0 10px",
                top: "40%",
              },
            }}
            indicatorContainerProps={{
              style: {
                marginTop: "10px",
                position: "absolute",
                bottom: "10px",
                zIndex: 2,
              },
            }}
          >
            {item?.campaignFiles.map((file: any, index: any) => {
              // Calculate video index for this specific video file
              const videoIndex = item?.campaignFiles
                .slice(0, index)
                .filter((f: any) => f.filePath.endsWith(".mp4")).length;

              return (
                <div
                  key={index}
                  className="relative flex items-center justify-center bg-black w-full h-[300px] rounded-lg"
                >
                  {file.filePath.endsWith(".mp4") ? (
                    <div className="relative w-full h-full group">
                      <video
                        ref={(el) => (videoRefs.current[videoIndex] = el)}
                        className="w-full h-full object-cover rounded-lg"
                        src={file.filePath}
                        controls={false}
                        // muted // Important for autoplay
                        loop // Optional: loop the video
                        playsInline // Better mobile support
                        onMouseEnter={() => handleVideoMouseEnter(videoIndex)}
                        onMouseLeave={() => handleVideoMouseLeave(videoIndex)}
                      />
                      {/* Clickable overlay for play/pause */}
                      <div
                        className="absolute inset-0 flex items-center justify-center cursor-pointer z-10"
                        onClick={() => togglePlayPause(videoIndex)}
                      >
                        {/* Center play/pause button - shows on hover or when paused */}
                        <div
                          className={`transition-opacity duration-300 ${
                            videoPlaying[videoIndex] && !showVideoControls[videoIndex]
                              ? "opacity-0 group-hover:opacity-100"
                              : "opacity-100"
                          }`}
                        >
                          <button
                            className="flex items-center justify-center w-16 h-16 bg-black bg-opacity-50 rounded-full hover:bg-opacity-70 transition-all"
                            onClick={(e) => {
                              e.stopPropagation();
                              togglePlayPause(videoIndex);
                            }}
                          >
                            {videoPlaying[videoIndex] ? (
                              <Pause className="w-8 h-8 text-white" />
                            ) : (
                              <Play className="w-8 h-8 text-white ml-1" />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <img
                      src={file.filePath || "/placeholder.svg"}
                      alt={`Campaign ${index}`}
                      className="w-full max-h-full object-contain rounded-lg"
                    />
                  )}
                </div>
              );
            })}
          </Carousel>
        </div>

        {/* Actions Section */}
        <div className="flex mt-4 mb-3 text-sm gap-5 justify-between items-center">
          <div className="flex">
            <div
              className="flex items-center cursor-pointer"
              onClick={() => {
               /* item?.campaignStatus == "Active" && */
                openShareCampaignModal();
              }}
            >
              <img
                src={share || "/placeholder.svg"}
                width={20}
                height={20}
                className="mr-1"
                alt="share"
              />
              <span>Endorse</span>
            </div>
            <div
              className="ml-2 flex items-center cursor-pointer"
              onClick={() => {
                openEndorseMenu();
              }}
            >
              <img
                src={endorse || "/placeholder.svg"}
                width={20}
                height={20}
                className="mr-1"
                alt="endorse"
              />
              <span>Promote</span>
            </div>
          </div>
          <div>
            <button
              className="bg-green-100 text-green-600 rounded-lg px-2 py-1 font-medium"
              style={{ fontSize: "0.7rem" }}
            >
              {item?.endorseCount} Endorsements
            </button>
          </div>
        </div>
      </div>

      <EndorseCampaignModal
        isOpen={endorseMenu}
        onClose={closeEndorseMenu}
        onSubmit={submitEndorsement}
      />

      <PaymentMethodModal
        isOpen={paymentMethodModal}
        onClose={closePaymentMethodModal}
        onSubmit={submitPaymentMethod}
      />

      <InsufficientWalletBalanceModal
        isOpen={insufficientWalletModal}
        onClose={closeInsufficientWalletModal}
        details={allData}
      />

      <SummaryModal
        isOpen={summaryModal}
        onClose={closeSummaryModal}
        onSubmit={PayWithWallet}
        details={allData}
        ApiLoading={ApiFeedbackLoading}
      />

      <EndorsementSuccessfulModal
        isOpen={endorsementSuccessfulModal}
        onClose={closeEndorsementSuccessfulModal}
        details={allData}
      />

      <ShareCampaignModal
        isOpen={shareCampaignModal}
        onClose={closeShareCampaignModal}
        details={item}
      />

      <SignInFirst isOpen={signInFirstModal} onClose={closeSignInPrompt} />
    </>
  );
};

export default HomeCampaign;
